import React, { useEffect, useState } from "react";

export default function LiveScores() {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMatches = async () => {
      setLoading(true);
      try {
        const today = new Date().toISOString().split("T")[0];
        const response = await fetch(
          `https://api.allorigins.win/raw?url=${encodeURIComponent("https://api.football-data.org/v4/matches?dateFrom=" + today + "&dateTo=" + today)}`,
          {
            headers: {
              "X-Auth-Token": "9fffa6028c674f879bc3d271ca5dfe22",
            },
          }
        );

        console.log("Response status:", response.status);
        const data = await response.json();
        console.log("API response:", data);

        if (response.ok) {
          setMatches(data.matches || []);
        } else {
          setError(`API error ${response.status}`);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Failed to load matches.");
      } finally {
        setLoading(false);
      }
    };

    fetchMatches();
  }, []);

  return (
    <section id="scores" className="mb-10">
      <h2 className="text-xl font-semibold mb-2 border-b border-gray-600 pb-1">
        Live Soccer Scores
      </h2>
      {loading ? (
        <p className="text-gray-400">Loading...</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : matches.length === 0 ? (
        <p className="text-gray-400">No live matches right now.</p>
      ) : (
        <ul className="space-y-4">
          {matches.map((match) => (
            <li key={match.id} className="bg-gray-800 p-4 rounded-lg">
              <p className="text-white font-medium">
                {match.homeTeam.name} vs {match.awayTeam.name}
              </p>
              <p className="text-sm text-gray-300">
                {match.competition.name} —{" "}
                {new Date(match.utcDate).toLocaleString()}
              </p>
              {match.score.fullTime.home !== null && (
                <p className="text-white mt-1">
                  Score: {match.score.fullTime.home} - {match.score.fullTime.away}
                </p>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
